import createInstanceCreateUtil from 'modules/redux/actions/create/create-instance'

export default function createInstancesCreateReduxUtil (stateWrapper, payload) {
  return payload.data.reduce((instances, obj) => {
    const instance = createInstanceCreateUtil(stateWrapper, {
      data: {
        data: obj,
        status: payload.status
      },
      className: payload.className,
      domainListPath: payload.domainListPath
    })
    instances.push(instance)
    return instances
  }, [])
}
